import React, { useRef } from 'react';
import CodeHighlight from './../../components/code-highlight/code-highlight.jsx';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function UIWidgetBoxes() {
	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<a href="#/">{'UI Elements'}</a>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									{' Widget Boxes '}
									<small>{'page header description goes here...'}</small>
								</h1>
								<hr className="mb-4" />
								<div id="basicUsage" className="mb-5">
									<h4>{'Basic Usage'}</h4>
									<p>
										{
											' Bootstrap’s cards provide a flexible and extensible content container with multiple variants and options. Please read the '
										}
										<a href="https://getbootstrap.com/docs/5.3/components/card/" target="_blank" rel="noreferrer">
											{'official Bootstrap documentation'}
										</a>
										{' for the full list of options. '}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div className="card-header-btn">
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-default"
																	data-toggle="card-expand"
																>
																	<i className="fa fa-expand"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-success"
																	data-toggle="card-reload"
																>
																	<i className="fa fa-redo"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-warning"
																	data-toggle="card-collapse"
																>
																	<i className="fa fa-minus"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-danger"
																	data-toggle="card-remove"
																>
																	<i className="fa fa-times"></i>
																</a>
															</div>
														</div>
														<div className="card-body">
															<div>{'Card content Here'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-1.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="hoverViewIcon" className="mb-5">
									<h4>{'Hover View Icon'}</h4>
									<p>
										{
											' This feature enhances the Bootstrap card by showing an action icon when the user hovers over the card. Place the icon inside the '
										}
										<code>{'.card'}</code>
										{
											' and use CSS hover effects to reveal it, providing quick access to actions like view, edit, or share without cluttering the card layout. '
										}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900 hover-focus-visible">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div className="card-header-btn">
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-default"
																	data-toggle="card-expand"
																>
																	<i className="fa fa-expand hover-focus-visible-elm"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-success"
																	data-toggle="card-reload"
																>
																	<i className="fa fa-redo hover-focus-visible-elm"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-warning"
																	data-toggle="card-collapse"
																>
																	<i className="fa fa-minus hover-focus-visible-elm"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-danger"
																	data-toggle="card-remove"
																>
																	<i className="fa fa-times hover-focus-visible-elm"></i>
																</a>
															</div>
														</div>
														<div className="card-body">
															<div>{'Card content Here'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-2.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withDropdownMenu" className="mb-5">
									<h4>{'with Dropdown Menu'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by adding a dropdown menu inside the card header. Use the '
										}
										<code>{'.dropdown'}</code>
										{' component with '}
										<code>{'.card-header'}</code>
										{
											' to provide additional actions or options without cluttering the card content. '
										}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div className="btn-group my-n1">
																<button
																	type="button"
																	className="btn btn-success btn-xs"
																>
																	{'Action'}
																</button>
																<button
																	type="button"
																	className="btn btn-success btn-xs dropdown-toggle"
																	data-bs-toggle="dropdown"
																>
																	<b className="caret"></b>
																</button>
																<div className="dropdown-menu dropdown-menu-end">
																	<a href="#/" className="dropdown-item">
																		{'Action'}
																	</a>
																	<a href="#/" className="dropdown-item">
																		{'Another action'}
																	</a>
																	<a href="#/" className="dropdown-item">
																		{'Something else here'}
																	</a>
																	<div className="dropdown-divider"></div>
																	<a href="#/" className="dropdown-item">
																		{'Separated link'}
																	</a>
																</div>
															</div>
														</div>
														<div className="card-body">
															<div>{'Card content Here'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-3.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withRadioButton" className="mb-5">
									<h4>{'with Radio Button'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by placing button-style radio options inside the card header. Use the '
										}
										<code>{'.btn-check'}</code>
										{' input with a corresponding '}
										<code>{'.btn'}</code>
										{' label to create toggleable radio buttons that fit neatly within the '}
										<code>{'.card-header'}</code>
										{'. '}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div
																className="btn-group btn-group-toggle my-n1"
																data-toggle="buttons"
															>
																<input
																	type="radio"
																	name="options"
																	className="btn-check"
																	id="option1"
																	autocomplete="off"
																	checked
																/>
																<label
																	className="btn btn-success btn-xs"
																	htmlFor="option1"
																>
																	{' Option 1'}
																</label>
																<input
																	type="radio"
																	name="options"
																	className="btn-check"
																	id="option2"
																	autocomplete="off"
																/>
																<label
																	className="btn btn-success btn-xs"
																	htmlFor="option2"
																>
																	{' Option 2'}
																</label>
															</div>
														</div>
														<div className="card-body">
															<div>{'Card content Here'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-4.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withProgressBar" className="mb-5">
									<h4>{'with Progress Bar'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by placing a progress bar inside the card header. Combine the '
										}
										<code>{'.progress'}</code>
										{' component with '}
										<code>{'.card-header'}</code>
										{' to visually indicate task completion or status directly on the card. '}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div className="progress h-10px bg-gray-700 w-150px">
																<div
																	className="progress-bar progress-bar-striped bg-success progress-bar-animated fw-bold"
																	style={{ width: '40%' }}
																>
																	{'40%'}
																</div>
															</div>
														</div>
														<div className="card-body">
															<div>{'Card content Here'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-5.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withBadge" className="mb-5">
									<h4>{'with Badge'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by adding a badge element inside the card header. Use the '
										}
										<code>{'.badge'}</code>
										{' component with '}
										<code>{'.card-header'}</code>
										{
											' to display counts, labels, or status indicators in a compact and visually clear way. '
										}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title '}
																<span className="badge bg-success ms-1">{'NEW'}</span>
															</h4>
															<div className="card-header-btn">
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-default"
																	data-toggle="card-expand"
																>
																	<i className="fa fa-expand"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-success"
																	data-toggle="card-reload"
																>
																	<i className="fa fa-redo"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-warning"
																	data-toggle="card-collapse"
																>
																	<i className="fa fa-minus"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-danger"
																	data-toggle="card-remove"
																>
																	<i className="fa fa-times"></i>
																</a>
															</div>
														</div>
														<div className="card-body">
															<div>{'Card content Here'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-6.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withAlertBox" className="mb-5">
									<h4>{'with Alert Box'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by placing an alert component inside the card body. Use the '
										}
										<code>{'.alert'}</code>
										{' classes within '}
										<code>{'.card'}</code>
										{
											' to display important messages, warnings, or status updates directly in the card content area. '
										}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div className="card-header-btn">
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-default"
																	data-toggle="card-expand"
																>
																	<i className="fa fa-expand"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-success"
																	data-toggle="card-reload"
																>
																	<i className="fa fa-redo"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-warning"
																	data-toggle="card-collapse"
																>
																	<i className="fa fa-minus"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-danger"
																	data-toggle="card-remove"
																>
																	<i className="fa fa-times"></i>
																</a>
															</div>
														</div>
														<div className="alert alert-success alert-dismissible fade show rounded-0 d-flex m-0">
															<div className="display-6">
																<iconify-icon icon="solar:check-circle-line-duotone"></iconify-icon>
															</div>
															<div className="small fw-semibold flex-1 ps-10px">
																{
																	' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ac posuere lacus, quis suscipit sem. Nulla sagittis aliquam erat non convallis. '
																}
															</div>
															<button
																type="button"
																className="btn-close"
																data-bs-dismiss="alert"
															></button>
														</div>
														<div className="card-body">
															<div>{'Card content Here'}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-7.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withScrollbar" className="mb-5">
									<h4>{'with Scrollbar'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by integrating a custom scrollbar plugin for smoother scrolling and a more polished look. Apply the plugin to the '
										}
										<code>{'.card-body'}</code>
										{
											' to handle long content elegantly, with support for styled scrollbars, better performance, and cross-browser consistency. '
										}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div className="card-header-btn">
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-default"
																	data-toggle="card-expand"
																>
																	<i className="fa fa-expand"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-success"
																	data-toggle="card-reload"
																>
																	<i className="fa fa-redo"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-warning"
																	data-toggle="card-collapse"
																>
																	<i className="fa fa-minus"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-danger"
																	data-toggle="card-remove"
																>
																	<i className="fa fa-times"></i>
																</a>
															</div>
														</div>
														<div className="card-body">
															<div data-scrollbar="true" data-height="250px">
																<p>
																	<span className="fa-stack fa-4x float-start me-10px text-dark">
																		<i className="fab fa-twitter fa-stack-1x"></i>
																	</span>
																	{
																		' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque sed enim arcu. Ut posuere in ligula quis ultricies. In in justo turpis. Donec ut dui at massa gravida interdum nec vitae justo. Quisque ullamcorper vehicula dictum. Nullam hendrerit interdum eleifend. Aenean luctus sed arcu laoreet scelerisque. Vivamus non ullamcorper mauris, id sagittis lorem. Proin tincidunt mauris et dolor mattis imperdiet. Sed facilisis mattis diam elementum adipiscing. '
																	}
																</p>
																<p>
																	<span className="fa-stack fa-4x float-end ms-10px text-dark">
																		<i className="fab fa-google-plus fa-stack-1x"></i>
																	</span>
																	{
																		' Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Ut ante velit, pretium non nisi a, egestas placerat diam. Nullam aliquet iaculis ultricies. Aliquam volutpat, sapien quis volutpat elementum, ligula purus auctor diam, at vestibulum nulla augue vel purus. Praesent ac nisl a magna tincidunt interdum sed in turpis. Maecenas nec condimentum risus. In congue pretium est, eget euismod tortor ornare quis. '
																	}
																</p>
																<p>
																	<span className="fa-stack fa-4x float-start me-10px text-dark">
																		<i className="fab fa-facebook fa-stack-1x"></i>
																	</span>
																	{
																		' Praesent eu ultrices justo. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Cras mattis ipsum quis sapien consectetur fringilla. Etiam sagittis sem tempus purus elementum, vitae pretium sapien porta. Curabitur iaculis ante ut aliquam luctus. Vivamus ullamcorper blandit imperdiet. Ut egestas, orci id rhoncus cursus, orci risus scelerisque enim, eget mattis eros lacus quis ligula. Vivamus ullamcorper urna eget hendrerit laoreet. '
																	}
																</p>
																<p>
																	<span className="fa-stack fa-4x float-end ms-10px text-dark">
																		<i className="fab fa-apple fa-stack-1x"></i>
																	</span>
																	{
																		' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi accumsan velit dolor. Donec convallis eleifend magna, at euismod tellus convallis a. Curabitur in nisi dolor. Cras viverra scelerisque orci, sed interdum ligula volutpat non. Nunc eu enim ac neque tempor feugiat. Duis posuere lacus non magna eleifend, non dictum sem feugiat. Duis eleifend condimentum pulvinar. '
																	}
																</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-8.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withToolbarFooter" className="mb-5">
									<h4>{'with Toolbar & Footer'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by including a functional toolbar in the header and an action footer at the bottom. The toolbar can host buttons, icons, or dropdowns for quick actions, while the footer provides space for secondary controls, notes, or status information, giving the card a complete and balanced layout. '
										}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<div className="card-header-btn">
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-default"
																	data-toggle="card-expand"
																>
																	<i className="fa fa-expand"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-success"
																	data-toggle="card-reload"
																>
																	<i className="fa fa-redo"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-warning"
																	data-toggle="card-collapse"
																>
																	<i className="fa fa-minus"></i>
																</a>
																<a
																	href="#/"
																	className="btn btn-xs btn-icon btn-danger"
																	data-toggle="card-remove"
																>
																	<i className="fa fa-times"></i>
																</a>
															</div>
														</div>
														<div className="d-flex gap-2 py-10px px-3">
															<div className="btn-group btn-group-sm">
																<a className="btn btn-white" href="#/">
																	<i className="fa fa-bold"></i>
																</a>
																<a className="btn btn-white active" href="#/">
																	<i className="fa fa-italic"></i>
																</a>
																<a className="btn btn-white" href="#/">
																	<i className="fa fa-underline"></i>
																</a>
															</div>
															<div className="btn-group btn-group-sm">
																<a className="btn btn-white" href="#/">
																	<i className="fa fa-align-left"></i>
																</a>
																<a className="btn btn-white active" href="#/">
																	<i className="fa fa-align-center"></i>
																</a>
																<a className="btn btn-white" href="#/">
																	<i className="fa fa-align-right"></i>
																</a>
																<a className="btn btn-white" href="#/">
																	<i className="fa fa-align-justify"></i>
																</a>
															</div>
														</div>
														<textarea
															className="form-control border-start-0 border-end-0 rounded-0 bg-light"
															rows="8"
														>
															{'This is a form textarea.'}
														</textarea>
														<div className="d-flex gap-2 py-10px px-3 justify-content-end">
															<a href="#/" className="btn btn-white btn-sm">
																{'Cancel'}
															</a>
															<a href="#/" className="btn btn-primary btn-sm">
																{'Action'}
															</a>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-9.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="withTabs" className="mb-5">
									<h4>{'with Tabs'}</h4>
									<p>
										{
											' This feature extends the Bootstrap card by placing navigation tabs inside the card header. Use '
										}
										<code>{'.nav-tabs'}</code>
										{' within '}
										<code>{'.card-header'}</code>
										{
											' to switch between multiple card body sections, keeping related content organized and accessible without leaving the card layout. '
										}
									</p>
									<div className="card">
										<div className="card-body p-4">
											<div className="row">
												<div className="col-xl-8">
													<div className="card card-borderless shadow-lg">
														<div className="card-header bg-gray-900">
															<h4 className="card-header-title text-white">
																{'Card title'}
															</h4>
															<ul className="nav nav-tabs nav-tabs-borderless nav-tabs-inverse mt-n2 mb-n3">
																<li className="nav-item">
																	<a
																		href="#home"
																		data-bs-toggle="tab"
																		className="nav-link active"
																	>
																		<i className="fa fa-home"></i>
																		<span className="d-none d-md-inline">
																			{'Home'}
																		</span>
																	</a>
																</li>
																<li className="nav-item">
																	<a
																		href="#profile"
																		data-bs-toggle="tab"
																		className="nav-link"
																	>
																		<i className="fa fa-user"></i>
																		<span className="d-none d-md-inline">
																			{'Profile'}
																		</span>
																	</a>
																</li>
															</ul>
														</div>
														<div className="card-body">
															<div className="tab-content">
																<div className="tab-pane fade show active" id="home">
																	<p>
																		{
																			"Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui."
																		}
																	</p>
																</div>
																<div className="tab-pane fade" id="profile">
																	<p>
																		{
																			"Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica VHS salvia yr, vero magna velit sapiente labore stumptown. Vegan fanny pack odio cillum wes anderson 8-bit, sustainable jean shorts beard ut DIY ethical culpa terry richardson biodiesel. Art party scenester stumptown, tumblr butcher vero sint qui sapiente accusamus tattooed echo park."
																		}
																	</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-10.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="sizing" className="mb-5">
									<h4>{'Sizing'}</h4>
									<p>
										{' Cards assume no specific '}
										<code>{'width'}</code>
										{
											' to start, so they’ll be 100% wide unless otherwise stated. You can change this as needed with custom CSS, grid classes, grid Sass mixins, or utilities. '
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row">
												<div className="col-sm-8">
													<div className="card">
														<div className="card-body">
															<h5 className="card-title">{'Special title treatment'}</h5>
															<p className="card-text">
																{
																	'With supporting text below as a natural lead-in to additional content.'
																}
															</p>
															<a href="#/" className="btn btn-outline-theme">
																{'Go somewhere'}
															</a>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-11.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="images" className="mb-5">
									<h4>{'Images'}</h4>
									<p>
										{
											' Cards include a few options for working with images. Choose from appending “image caps” at either end of a card, overlaying images with card content, or simply embedding the image in a card. '
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row gy-3">
												<div className="col-xl-6">
													<div className="small text-body text-opacity-50 mb-3">
														<b className="fw-bold">{'IMAGE CAPS'}</b>
													</div>
													<div className="card overflow-hidden">
														<img
															src="https://placehold.co/600x400/dee2e6/161a1d"
															alt=""
															className="card-img-top rounded-0"
														/>
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
												<div className="col-xl-6">
													<div className="small text-body text-opacity-50 mb-3">
														<b className="fw-bold">{'IMAGE OVERLAY'}</b>
													</div>
													<div className="card border-0 border-0">
														<img
															src="https://placehold.co/600x690/000000/ffffff"
															alt=""
															className="card-img"
														/>
														<div className="card-img-overlay m-3 text-white">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
																}
															</p>
															<p className="card-text">{'Last updated 3 mins ago'}</p>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-12.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="horizontal" className="mb-5">
									<h4>{'Horizontal'}</h4>
									<p>
										{
											' Using a combination of grid and utility classes, cards can be made horizontal in a mobile-friendly and responsive way. '
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="card">
												<div className="card-body">
													<div className="row gx-0 align-items-center">
														<div className="col-md-4">
															<img
																src="https://placehold.co/480x360/dee2e6/161a1d"
																alt=""
																className="card-img rounded-0"
															/>
														</div>
														<div className="col-md-8">
															<div className="card-body">
																<h5 className="card-title">{'Card title'}</h5>
																<p className="card-text">
																	{
																		'This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
																	}
																</p>
																<p className="card-text">
																	<small className="text-muted">
																		{'Last updated 3 mins ago'}
																	</small>
																</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-13.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="cardStyles" className="mb-5">
									<h4>{'Card Styles'}</h4>
									<p>
										{
											' Cards include various options for customizing their backgrounds, borders, and color. '
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row gy-3">
												<div className="col-xl-6">
													<div className="small text-body text-opacity-50 mb-3">
														<b className="fw-bold">{'BACKGROUND AND BORDER'}</b>
													</div>
													<div className="card border-dark bg-gray-900 text-white">
														<div className="card-header bg-dark fw-bold small border-dark">
															{'HEADER'}
														</div>
														<div className="card-body">
															<h5 className="card-title">{'Primary card title'}</h5>
															<p className="card-text text-white text-opacity-75">
																{
																	"Some quick example text to build on the card title and make up the bulk of the card's content."
																}
															</p>
														</div>
													</div>
												</div>
												<div className="col-xl-6">
													<div className="small text-body text-opacity-50 mb-3">
														<b className="fw-bold">{'BORDER AND COLOR'}</b>
													</div>
													<div className="card border-theme">
														<div className="card-header border-theme text-theme fw-bold small">
															{'HEADER'}
														</div>
														<div className="card-body">
															<h5 className="card-title text-theme">
																{'Primary card title'}
															</h5>
															<p className="card-text text-theme text-opacity-75">
																{
																	"Some quick example text to build on the card title and make up the bulk of the card's content."
																}
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-14.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="cardGroups" className="mb-5">
									<h4>{'Card Groups'}</h4>
									<p>
										{
											' Use card groups to render cards as a single, attached element with equal width and height columns. Card groups use '
										}
										<code>{'display: flex;'}</code>
										{' to achieve their uniform sizing. '}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="card-group">
												<div className="card">
													<div className="card-body">
														<h5 className="card-title">{'Card title'}</h5>
														<p className="card-text">
															{
																'This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
															}
														</p>
														<p className="card-text">
															<small className="text-muted">
																{'Last updated 3 mins ago'}
															</small>
														</p>
													</div>
												</div>
												<div className="card">
													<div className="card-body">
														<h5 className="card-title">{'Card title'}</h5>
														<p className="card-text">
															{
																'This card has supporting text below as a natural lead-in to additional content.'
															}
														</p>
														<p className="card-text">
															<small className="text-muted">
																{'Last updated 3 mins ago'}
															</small>
														</p>
													</div>
												</div>
												<div className="card">
													<div className="card-body">
														<h5 className="card-title">{'Card title'}</h5>
														<p className="card-text">
															{
																'This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.'
															}
														</p>
														<p className="card-text">
															<small className="text-muted">
																{'Last updated 3 mins ago'}
															</small>
														</p>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-15.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="cardGrid" className="mb-5">
									<h4>{'Card Grid'}</h4>
									<p>
										{' Use the Bootstrap grid system and its '}
										<a href="https://getbootstrap.com/docs/5.3/layout/grid/#row-columns">
											<code>{'.row-cols'}</code>
											{' classes'}
										</a>
										{
											' to control how many grid columns (wrapped around your cards) you show per row. For example, here’s '
										}
										<code>{'.row-cols-1'}</code>
										{' laying out the cards on one column, and '}
										<code>{'.row-cols-md-2'}</code>
										{
											' splitting four cards to equal width across multiple rows, from the medium breakpoint up. '
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row row-cols-1 row-cols-md-2 g-3">
												<div className="col">
													<div className="card h-100">
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
												<div className="col">
													<div className="card h-100">
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This card has supporting text below as a natural lead-in to additional content.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
												<div className="col">
													<div className="card h-100">
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
												<div className="col">
													<div className="card h-100">
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-16.json"
												/>
											</pre>
										</div>
									</div>
								</div>
								<div id="cardColumns" className="mb-5">
									<h4>{'Card Columns'}</h4>
									<p>
										{' In '}
										<code>{'v5'}</code>
										{
											', cards can be organized into Masonry-like columns with masonry javascript included. '
										}
									</p>
									<div className="card">
										<div className="card-body">
											<div className="row gy-4" data-masonry='{"percentPosition": true }'>
												<div className="col-sm-6 col-lg-4">
													<div className="card">
														<div className="card-body">
															<h5 className="card-title">
																{'Card title that wraps to a new line'}
															</h5>
															<p className="card-text">
																{
																	'This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
																}
															</p>
														</div>
													</div>
												</div>
												<div className="col-sm-6 col-lg-4">
													<div className="card p-3">
														<blockquote className="blockquote mb-0 card-body">
															<p>
																{
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
																}
															</p>
															<footer className="blockquote-footer">
																<small className="text-muted">
																	{' Someone famous in '}
																	<cite title="Source Title">{'Source Title'}</cite>
																</small>
															</footer>
														</blockquote>
													</div>
												</div>
												<div className="col-sm-6 col-lg-4">
													<div className="card">
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This card has supporting text below as a natural lead-in to additional content.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
												<div className="col-sm-6 col-lg-4">
													<div className="card text-center">
														<blockquote className="blockquote mb-0 card-body">
															<p>
																{
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat.'
																}
															</p>
															<footer className="blockquote-footer text-white">
																<small>
																	{' Someone famous in '}
																	<cite title="Source Title">{'Source Title'}</cite>
																</small>
															</footer>
														</blockquote>
													</div>
												</div>
												<div className="col-sm-6 col-lg-4">
													<div className="card text-center">
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This card has a regular title and short paragraphy of text below it.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
												<div className="col-sm-6 col-lg-4">
													<div className="card p-3 text-end">
														<blockquote className="blockquote mb-0">
															<p>
																{
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
																}
															</p>
															<footer className="blockquote-footer">
																<small className="text-muted">
																	{' Someone famous in '}
																	<cite title="Source Title">{'Source Title'}</cite>
																</small>
															</footer>
														</blockquote>
													</div>
												</div>
												<div className="col-sm-6 col-lg-4">
													<div className="card">
														<div className="card-body">
															<h5 className="card-title">{'Card title'}</h5>
															<p className="card-text">
																{
																	'This is another card with title and supporting text below. This card has some additional content to make it slightly taller overall.'
																}
															</p>
															<p className="card-text">
																<small className="text-muted">
																	{'Last updated 3 mins ago'}
																</small>
															</p>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<pre>
												<CodeHighlight
													className="xml"
													src="/color-admin/admin/react/assets/data/ui-widget-boxes/code-17.json"
												/>
											</pre>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav">
										<a className="nav-link active" href="#basicUsage" data-toggle="scroll-to">
											{'Basic usage'}
										</a>
										<a className="nav-link" href="#hoverViewIcon" data-toggle="scroll-to">
											{'Hover View Icon'}
										</a>
										<a className="nav-link" href="#withDropdownMenu" data-toggle="scroll-to">
											{'with Dropdown Menu'}
										</a>
										<a className="nav-link" href="#withRadioButton" data-toggle="scroll-to">
											{'with Radio Button'}
										</a>
										<a className="nav-link" href="#withProgressBar" data-toggle="scroll-to">
											{'with Progress Bar'}
										</a>
										<a className="nav-link" href="#withBadge" data-toggle="scroll-to">
											{'with Badge'}
										</a>
										<a className="nav-link" href="#withAlertBox" data-toggle="scroll-to">
											{'with Alert Box'}
										</a>
										<a className="nav-link" href="#withScrollbar" data-toggle="scroll-to">
											{'with Scrollbar'}
										</a>
										<a className="nav-link" href="#withToolbarFooter" data-toggle="scroll-to">
											{'with Toolbar & Footer'}
										</a>
										<a className="nav-link" href="#withTabs" data-toggle="scroll-to">
											{'with Tabs'}
										</a>
										<a className="nav-link" href="#sizing" data-toggle="scroll-to">
											{'Sizing'}
										</a>
										<a className="nav-link" href="#images" data-toggle="scroll-to">
											{'Images'}
										</a>
										<a className="nav-link" href="#horizontal" data-toggle="scroll-to">
											{'Horizontal'}
										</a>
										<a className="nav-link" href="#cardStyles" data-toggle="scroll-to">
											{'Card styles'}
										</a>
										<a className="nav-link" href="#cardGroups" data-toggle="scroll-to">
											{'Card groups'}
										</a>
										<a className="nav-link" href="#cardGrid" data-toggle="scroll-to">
											{'Card grid'}
										</a>
										<a className="nav-link" href="#cardColumns" data-toggle="scroll-to">
											{'Card columns'}
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default UIWidgetBoxes;
